/* BLED ELEVEN — badges de confiance de la fiche produit (snippets/bled-product-reassurance.liquid).
   1. Recalcule les dates de livraison à l'heure du client (jours ouvrés : +1/+2 expédition, +5/+8 réception).
   2. Ouvre / ferme les panneaux de détail (un seul ouvert à la fois). */
(function () {
  'use strict';
  if (window.__btrReady) return;
  window.__btrReady = true;

  var MO = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var NB = String.fromCharCode(160); // espace insécable : « 20 oct. » ne se coupe jamais en fin de ligne

  function addBD(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate()), k = 0;
    while (k < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) k++;
    }
    return d;
  }
  function day(d) { var n = d.getDate(); return n === 1 ? '1er' : String(n); }
  function range(a, b) {
    return a.getMonth() === b.getMonth()
      ? day(a) + '–' + day(b) + NB + MO[b.getMonth()]
      : day(a) + NB + MO[a.getMonth()] + '–' + day(b) + NB + MO[b.getMonth()];
  }
  function between(a, b) {
    return a.getMonth() === b.getMonth()
      ? 'entre le' + NB + day(a) + ' et le' + NB + day(b) + NB + MO[b.getMonth()]
      : 'entre le' + NB + day(a) + NB + MO[a.getMonth()] + ' et le' + NB + day(b) + NB + MO[b.getMonth()];
  }
  function put(root, sel, txt) {
    var list = root.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) if (list[i].textContent !== txt) list[i].textContent = txt;
  }
  function dates(root) {
    var now = new Date();
    var s1 = addBD(now, 1), s2 = addBD(now, 2), r1 = addBD(now, 5), r2 = addBD(now, 8);
    put(root, '[data-btr-when]', between(r1, r2));
    put(root, '[data-btr-ship]', range(s1, s2));
    put(root, '[data-btr-recv]', range(r1, r2));
  }

  function closeAll(root) {
    var t = root.querySelectorAll('[data-btr-t]'), p = root.querySelectorAll('[data-btr-p]'), i;
    for (i = 0; i < t.length; i++) t[i].setAttribute('aria-expanded', 'false');
    for (i = 0; i < p.length; i++) { p[i].classList.remove('is-open'); p[i].setAttribute('aria-hidden', 'true'); }
  }

  function reveal(panel) {
    // Après l'animation, si le panneau dépasse en bas de l'écran (barre d'achat collante comprise), on le fait remonter.
    setTimeout(function () {
      var r = panel.getBoundingClientRect(), limit = window.innerHeight - 96;
      if (r.bottom > limit) {
        var dy = Math.min(r.bottom - limit, Math.max(0, r.top - 72));
        if (dy > 4) {
          try { window.scrollBy({ top: dy, behavior: 'smooth' }); } catch (e) { window.scrollBy(0, dy); }
        }
      }
    }, 340);
  }

  function init(root) {
    if (root.__btr) return;
    root.__btr = true;
    dates(root);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-btr-t]') : null;
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var wasOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll(root);
      if (wasOpen) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      reveal(panel);
    });
  }

  function boot() {
    var list = document.querySelectorAll('[data-btr]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  // Onglet resté ouvert plusieurs jours : on remet les dates à jour au retour sur la page.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    var list = document.querySelectorAll('[data-btr]');
    for (var i = 0; i < list.length; i++) dates(list[i]);
  });
})();
